<template>
  <div>
    <el-steps :active="resourceQrGenerateProcess" class="stepClass" align-center="true">
      <el-step>
        <span slot="title">
          <i class="fa fa-edit fa-x"></i>编辑内容</span>
      </el-step>
      <el-step>
        <span slot="title">
          <i class="fa fa-upload fa-x"></i>上传图片</span>
      </el-step>
      <el-step>
        <span slot="title">
          <i class="fas fa-cut fa-x"></i>裁剪图片</span>
      </el-step>
      <el-step>
        <span slot="title">
          <i class="far fa-save fa-x"></i>保存图片</span>
      </el-step>
    </el-steps>
    <el-col v-if="resourceQrGenerateProcess == 0" style="text-align: center;">
      <div class="editorArea">
      <div class="editorHead">
        <el-row>
          <el-col :span="8"><el-input v-model="textTitle" placeholder="标题" style="border-bottom:solid 1px black;"></el-input></el-col>
          <el-col :span="4" style="margin-left:20px;border-bottom:solid 1px black;"><el-input v-model="textAuthor" placeholder="作者"></el-input></el-col>
        </el-row>
        <div id="editorHead" class=""></div>
        </div>
        <div id="editorBody" class="editorBody"></div>
        </div>
      <el-button @click="submitResource" class="button1" style="margin-top:20px;">下一步</el-button>
    </el-col>
    <!-- <el-button @click="submitResource" class="button1" style="margin-top:20px;">下一步</el-button> -->
    <el-col v-if="resourceQrGenerateProcess == 1" :span="24">
      <el-upload drag class="qr-src-uploader" action="" :on-change="onUploadChange" :multiple="false" :auto-upload="false">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将资源美钥码图片拖到此处，或
          <em>点击上传</em>
        </div>
      </el-upload>
      <!-- <el-button @click="resourceQrGenerateProcess--" class="button2">上一步</el-button> -->
    </el-col>
    <el-col v-if="resourceQrGenerateProcess == 2" :span="24" style="text-align: center;">
      <cropper :src="selectedPic.url" @api="getCropApi" class="cropper"></cropper>
      <el-button @click="cropImage" class="button2">下一步</el-button>
    </el-col>
    <el-col v-if="resourceQrGenerateProcess == 3" :span="24" style="text-align: center;">
      <div style="text-align:center;margin-top:20px;">
        <img :src="'/qrdata/temp/' + qr.qrfile" class="disqr" alt="美钥二维码">
      </div>
      <div class="button_box">
        <el-button @click="resourceQrGenerateProcess--" class="button5">重新裁剪</el-button>
        <el-button @click="saveQr" class="button6">保存图片</el-button>
      </div>
    </el-col>
  </div>
</template>


<script src="//unpkg.com/wangeditor/release/wangEditor.min.js"></script>

<script type="text/javascript">
import $ from 'jquery'
import cropper from './cropper.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'qrUrl',
  components: {
    cropper
  },
  data () {
    // 校验函数，检验网址是否为url
    let isUrl = (rule, value, callback) => {
      if (value === '') {
        this.$message.warning('网址不能为空')
      } else if (value.length > 2083) {
        this.$message.warning('网址太长，请尝试输入短网址')
      } else if (!(value.slice(0, 'http://'.length) === 'http://' || value.slice(0, 'https://'.length) === 'https://')) {
        this.$message.warning('网址应该以"http://"或者"https://"开头')
      } else if (value === 'http://' || value === 'https://') {
        this.$message.warning('请填入具体网址')
      } else {
        callback()
      }
    }
    return {
      resourceQrGenerateProcess: 0,
      imageUrl: '',
      // 网址
      qrWebInfoForm: {
        url: 'http://'
      },
      // 校验网址是否合乎规定
      qrWebRules: {
        url: [
          { validator: isUrl, trigger: 'click' }
        ]
      },
      selectedPic: '', // 上传的图像本地文件地址及名称，blob
      cropperApi: undefined,
      // canvasDataURL: undefined // canvas data
      qr: undefined, // 生成的二维码
      editor: undefined,
      resource: undefined,
      textTitle: '',
      textAuthor: ''
    }
  },
  mounted () {
    document.title = '美钥二维码 - 制作文本美钥码'
    let E = window.wangEditor
    this.editor = new E('#editorHead', '#editorBody')
    this.editor.customConfig.uploadImgShowBase64 = true
    this.editor.customConfig.menus = [
      'head',  // 标题
      'bold',  // 粗体
      'italic',  // 斜体
      'underline',  // 下划线
      'strikeThrough',  // 删除线
      'foreColor',  // 文字颜色
      'backColor',  // 背景颜色
      'link',  // 插入链接
      'list',  // 列表
      'justify',  // 对齐方式
      'quote',  // 引用
      'image',  // 插入图片
      'table',  // 表格
      'video',  // 插入视频
      'code',  // 插入代码
      'undo',  // 撤销
      'redo'  // 重复
    ]
    // this.editor.customConfig.onchange = function (html) {
    //   vm.$message.info(vm.getBytes('1234 z'))
    // }
    this.editor.create()
  },
  computed: {
    ...mapGetters(['logined', 'username'])
  },
  methods: {
    submitResource () {
      const vm = this
      if (vm.textTitle === '') {
        vm.$message.warning('标题不能为空！')
      } else {
        // 进行资源校验
        $.ajax({
          type: 'POST',
          url: '/v1/text/check',
          data: {resource: vm.editor.txt.html()},
          dataType: 'json',
          success: function (response) {
            if (response.data === 'ok') {
              vm.resourceQrGenerateProcess++
              // 这里要对数据中的时间处理一下，否则时区问题导致时间错误
              // let time = vm.textDate.getFullYear() + '-' + (vm.textDate.getMonth() + 1) + '-' + vm.textDate.getDate() + ' ' + vm.textDate.getHours() + ':' + vm.textDate.getMinutes() + ':' + vm.textDate.getSeconds()
              let temp = {text: vm.editor.txt.html(), title: vm.textTitle, author: vm.textAuthor}
              vm.resource = temp
            } else {
              vm.$message.warning('编辑内容超过单个文本美钥码容量上限，请减小编辑内容的大小！')
            }
          }
        })
      }
    },
    // 校验第一步输入的内容，并进入第二步
    secondStep (formName) {
      const vm = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          vm.urlQrGenerateProcess = 1
        } else {
          return false
        }
      })
    },
    onUploadChange (file, fileList) {
      const vm = this
      // 进入第3步
      vm.selectedPic = file
      vm.resourceQrGenerateProcess = vm.resourceQrGenerateProcess + 1
    },
    getCropApi (api) {
      this.cropperApi = api
    },
    dataURLtoBlob (dataurl) {
      let arr = dataurl.split(',')
      let mime = arr[0].match(/:(.*?);/)[1]
      let bstr = atob(arr[1])
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    },
    cropImage () {
      const vm = this
      if (vm.cropperApi) {
        let canvas = vm.cropperApi.getCroppedCanvas({
          width: 512
        })
        let canvasDataURL = canvas.toDataURL('image/jpeg')
        let blob = vm.dataURLtoBlob(canvasDataURL)
        // 上传图像，并进行图像生成
        let formData = new FormData()
        formData.append('url', vm.qrWebInfoForm.url)
        formData.append('srcImage', blob, 'cropImage.jpg')
        formData.append('resource', JSON.stringify(vm.resource))
        formData.append('type', 'resource')
        $.ajax({
          url: '/v1/generate/qr',
          type: 'POST',
          data: formData,
          async: false,
          enctype: 'multipart/form-data',
          processData: false,  // 告诉jQuery不要去处理发送的数据
          contentType: false,   // 告诉jQuery不要去设置Content-Type请求头
          cache: false
        })
        .done(function (data) {
          // 接受生成的二维码信息数据
          vm.qr = data.data
          // 跳转到下个界面
          vm.urlQrGenerateProcess ++
          vm.resourceQrGenerateProcess ++
        })
        .fail(function () {
          vm.$message.error('请求错误，请稍后再试！')
        })
      }
    },
    // 保存生成的美钥码
    saveQr () {
      const vm = this
      vm.$http.put(`/v1/user/qrs/${vm.qr.qrid}/owner`)
      .then(response => {
        if (response.data.code === 200) {
          vm.$message.info('保存成功！')
          vm.$router.push('/labelManage/labelid/all/n/10/p/1')
        } else {
          vm.$message.error('保存失败，请稍后再试')
        }
      }).catch((error) => {
        console.log(error)
        if (error.response.status === 507) {
          // 空间资源不足
          if (error.response.data.code === 507001) {
            vm.$message.warning('用户资源空间不足，请升级套餐进行扩容，或者清理部分空间后重试。')
          // 二维码空间不足
          } else if (error.response.data.code === 507002) {
            vm.$message.warning('用户资源空间不足，请升级套餐进行扩容，或者删除部分二维码后重试。')
          }
        }
      })
    }
  }
}
</script>


<style>
.editorArea {
  padding-top: 10px;
  margin-top: 20px;
  height: 700px;
  width: 50%;
  margin-left: 25%;
  overflow: hidden;
  background: white;
  text-align: left;
}
.editorHead {
  height: 10%;
}
.editorBody {
  height: 90%;
}
.editorBody img {
  /* width: 100%; */
  display: block;
  margin: 0 auto 0 auto;
}
.saveButton {
  width:20%;
  margin-left: 40%;
  margin-top:20px;
  background: #fe816d;
  border: #fe816d 1px solid;
  color: white;
  box-shadow: 2px 2px 20px #fe816d;
}
.saveButton:hover {
  background: #fa7662;
  
}
@media (max-width: 420px) {
  .editorArea {
    margin-top: 2px;
    width: 100%;
    margin-left: 0%;
  }
  .saveButton {
    margin-top: 10px;
  }
  .editorArea {
    border: none;
  }
}
</style>
